import React, { useEffect } from 'react';
import '@radix-ui/themes/styles.css';
import { Theme } from '@radix-ui/themes';
import * as Toast from '@radix-ui/react-toast';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';

import './App.css';
import 'react-simple-keyboard/build/css/index.css';

import { LanguageProvider } from './contexts/language/LanguageContext';
import { Main } from './layout/main/Main';
import { KioskConfigurationProvider } from './contexts/kioskConfiguration/KioskConfigurationContext';
import { Notifications } from './components/notification/Notifications';
import { ActivityChecker } from './components/activityChecker/ActivityChecker';
import { KeyboardProvider } from './contexts/keyboard/KeyboardContext';
import { toggleKioskMode } from './store/slices/app/appSlice';
import ErrorPage from './ErrorPage';


export const KIOSK_PARAM = 'kiosk'
export const KIOSK_PARAM_ON_FLAG = 'true'

const App = (): React.ReactElement => {
  const dispatch = useDispatch()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    dispatch(toggleKioskMode(queryParams.get(KIOSK_PARAM) === KIOSK_PARAM_ON_FLAG));
  }, []);

  return (
    <ErrorBoundary fallback={<ErrorPage />}>
      <Theme className="h-full">
        <Toast.Provider swipeDirection="left">
          <Notifications />
          <BrowserRouter>
            <KioskConfigurationProvider>
              <LanguageProvider language="cs">
                <KeyboardProvider>
                  <ActivityChecker />
                  <Main />
                  <Toast.Viewport className="ToastViewport" />
                </KeyboardProvider>
              </LanguageProvider>
            </KioskConfigurationProvider>
          </BrowserRouter>
        </Toast.Provider>
      </Theme>
    </ErrorBoundary>
  );
}

export default App;
